const ZIP_MIME_TYPES = new Set([
  "application/zip",
  "application/x-zip-compressed",
]);

/**
 * Checks whether a file is a ZIP archive by MIME type or `.zip` extension.
 * @param fileName - The file name to check
 * @param mimeType - The MIME type to check
 * @returns True if the file is a ZIP archive
 */
export function isZipFile(fileName: string, mimeType: string): boolean {
  if (ZIP_MIME_TYPES.has(mimeType)) {
    return true;
  }
  return fileName.toLowerCase().endsWith(".zip");
}

/**
 * Splits a file name into its base name and extension (dot included). A name
 * without a dot, or starting with its only dot, has an empty extension.
 */
export function splitFileName(fileName: string): {
  baseName: string;
  extension: string;
} {
  const lastDotIndex = fileName.lastIndexOf(".");
  if (lastDotIndex <= 0) {
    return { baseName: fileName, extension: "" };
  }
  return {
    baseName: fileName.slice(0, lastDotIndex),
    extension: fileName.slice(lastDotIndex),
  };
}
